import React, {useEffect, useState} from 'react';
import {Link, useLocation, useNavigate, useOutletContext, useParams, useSearchParams} from 'react-router-dom';
import TitleMain from "../../../components/Title/TitleMain";
import {useModal} from "../../../contexts/ModalContext";
import {useUser} from "../../../contexts/UserContext";
import {generateBreadcrumbSegmentsAdmin} from "../../../services/BreadcrumbService";
import {useBreadcrumb} from "../../../contexts/BreadcrumbContext";
import stylesCard from "../../../components/Card/AdminCard.module.css";
import AdminCard from "../../../components/Card/AdminCard";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faAllergies,
    faCaretLeft,
    faCaretRight,
    faMailBulk,
    faRemoveFormat,
    faSearch
} from "@fortawesome/free-solid-svg-icons";
import {faDAndDBeyond} from "@fortawesome/free-brands-svg-icons";
import AxiosConfig from "../../../services/AxiosConfig";

function AdminCrmMainPage() {
    const {user} = useUser();
    const {updateDynamicBreadcrumb} = useBreadcrumb();
    const {showModal, hideModal} = useModal();
    const [stateDisableEmail, setStateDisableEmail] = useState(null);

    const handleSuccess = (children = "Enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 1500});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 1500});
    };

    useEffect(() => {
        if (user.roles.includes("ROLE_SUPER_ADMIN")) {
            verifyDisableEmail();
        }
    }, []);

    useEffect(() => {
        updateDynamicBreadcrumb(generateBreadcrumbSegmentsAdmin({}));
    }, []);

    const verifyDisableEmail = async () => {
        try {
            const response = await AxiosConfig.get(`/admin/crm/crm_status`);
            setStateDisableEmail(response.data.status);
        } catch (error) {
            console.error('error', error);
        }
    }

    const handleDisableEmail = async (e) => {
        await handleSetCrmDisable(true);
    };

    const handleEnableEmail = async (e) => {
        await handleSetCrmDisable(false);
    };

    const handleSetCrmDisable = async (disable) => {
        try {
            const data = await disableEmail(disable);
            if (data.success) {
                handleSuccess(data.msg);
                setStateDisableEmail(disable);
            } else {
                handleError(data.msg);
            }
        } catch (error) {
            handleError(error);
        }
    };

    const disableEmail = async (disable) => {
        const response = await AxiosConfig.post(`/admin/crm/crm_disabled`, {disable: disable});
        return response.data;
    }

    return (
        <div className="content">
            <TitleMain text="CRM"/>

            <div className={stylesCard.adminCardContainer}>
                <AdminCard lien="types" titre="Types"/>
                <AdminCard lien="user_history" titre="Historique"/>
                <AdminCard lien="user_optin" titre="Actions"/>
            </div>

            <div style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
            }}>
                <p className={"text_info"}>
                    {stateDisableEmail === true ?
                        " L'envoi des mails est actuellement désactivé"
                        : stateDisableEmail === false ?
                            " L'envoi des mails est actuellement activé"
                            :
                            ""
                    }
                </p>

                {stateDisableEmail === true ? (
                    <button className={"btn btn_success"} onClick={handleEnableEmail}>
                        <FontAwesomeIcon icon={faMailBulk}/>
                        {" "} Activer l'envoi des mails
                    </button>
                ) : stateDisableEmail === false ? (
                    <button className={"btn btn_danger"} onClick={handleDisableEmail}>
                        <FontAwesomeIcon icon={faMailBulk}/>
                        {" "} Désactiver l'envoi des mails
                    </button>
                ) : ('')
                }
            </div>
        </div>
    )
}

export default AdminCrmMainPage;
